<template>
  <div class="portfolio-container main-content">
    <custom-headers :title="headerTitle" />
    <div
      class="backpage-container"
      @mouseenter="triggerBackpageAnimate()"
      @mouseleave="offBackpageAnimate()"
      @click="backpage"
    >
      <lottie
        :options="backpageDefaultOptions"
        @animCreated="anim => backpageHandleAnimation(anim)"
      />
    </div>
    <div class="portfolio-article">
      <a-col
        :span="24"
        class="portfolio-section d-flex flex-wrap"
        v-for="(portfolioItem, portfolioIndex) in portfolioList"
        :key="'portfolioItem' + portfolioIndex"
      >
        <div
          class="card-container"
          :style="{ backgroundColor: portfolioItem.cardColor }"
        >
          <div class="card-article">
            <div class="card-article-header">
              <h1>{{ portfolioItem.name }}</h1>
              <span>{{ portfolioItem.secondaryName }}</span>
            </div>
            <ul class="card-article-content">
              <li
                v-for="(skillsItem, skillsIndex) in portfolioItem.skills"
                :key="'skills' + skillsIndex"
                :style="{ color: portfolioItem.skillsFontColor }"
              >
                {{ skillsItem }}
              </li>
            </ul>
          </div>
          <div class="card-img">
            <img :src="portfolioItem.thumbnailSrc" />
          </div>
          <a
            v-if="portfolioItem.website"
            class="website-arrow-container"
            :href="portfolioItem.website"
          >
            <span>Website</span>
            <font-awesome-icon :icon="['far', 'arrow-alt-circle-right']" />
          </a>
        </div>
        <div class="portfolio-section-description d-flex flex-wrap">
          <p>
            {{ portfolioItem.description.article }}
          </p>
          <div
            v-html="portfolioItem.customHtml"
            class="custom-html-container"
          ></div>
          <span
            v-if="Object.keys(portfolioItem.description.moreContent).length > 0"
            class="portfolio-section-description-more"
            @click="toggleMoreDescrption(portfolioIndex)"
          >
            More
            <font-awesome-icon
              :icon="['fas', 'chevron-down']"
              :class="{ animate: isShowMoreDescriptionArr[portfolioIndex] }"
            />
          </span>
        </div>
        <div class="divider-container">
          <a-divider />
        </div>
        <viewer
          :images="viewerImages"
          @inited="viewerInited"
          class="viewer"
          ref="viewer"
        >
          <a-col
            :span="24"
            class="portfolio-section-imgs-description d-flex"
            :class="{ animate: isShowMoreDescriptionArr[portfolioIndex] }"
          >
            <ul class="imgs-description-left">
              <li
                v-for="(leftSideItem, leftSideIndex) in portfolioItem
                  .description.moreContent.leftSide"
                :key="'leftSide' + leftSideIndex"
              >
                <img :src="leftSideItem.imgSrc" />
              </li>
            </ul>
            <ul class="imgs-description-right">
              <li
                v-for="(rightSideItem, rightSideIndex) in portfolioItem
                  .description.moreContent.rightSide"
                :key="'rightSide' + rightSideIndex"
              >
                <img :src="rightSideItem.imgSrc" />
              </li>
            </ul>
          </a-col>
        </viewer>
      </a-col>
    </div>
    <div
      class="scrolltop-container"
      @click="scrollToTop"
      v-show="isShowScrollTopElement"
    >
      <lottie :options="scrollTopDefaultOptions" />
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Divider } from "ant-design-vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { faArrowAltCircleRight } from "@fortawesome/free-regular-svg-icons";
import Lottie from "vue-lottie";
import * as backArrowJSON from "../assets/json/back-arrow.json";
import * as scrollTopJSON from "../assets/json/rocket.json";
import CustomHeaders from "../components/Header.vue";
import thumbnailSrc1 from "../assets/img/nms.jpg";
import section1LeftSideImg1 from "../assets/img/nms-demo3.png";
import section1LeftSideImg2 from "../assets/img/nms-demo4.png";
import section1LeftSideImg3 from "../assets/img/nms-demo5.png";
import section1RightSideImg1 from "../assets/img/nms-demo1.png";
import section1RightSideImg2 from "../assets/img/nms-demo2.png";
import thumbnailSrc2 from "../assets/img/wm-system.jpg";
import section2LeftSideImg1 from "../assets/img/wm-system-demo3.png";
import section2LeftSideImg2 from "../assets/img/wm-system-demo4.png";
import section2LeftSideImg3 from "../assets/img/wm-system-demo5.png";
import section2RightSideImg1 from "../assets/img/wm-system-demo1.png";
import section2RightSideImg2 from "../assets/img/wm-system-demo2.png";
import thumbnailSrc3 from "../assets/img/litloyal.jpg";
import section3LeftSideImg1 from "../assets/img/litloyal-demo3.png";
import section3LeftSideImg2 from "../assets/img/litloyal-demo4.png";
import section3LeftSideImg3 from "../assets/img/litloyal-demo5.png";
import section3RightSideImg1 from "../assets/img/litloyal-demo1.png";
import section3RightSideImg2 from "../assets/img/litloyal-demo2.png";
import thumbnailSrc4 from "../assets/img/reward-system.jpg";

import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer/src/component.vue";

Vue.use(Divider);
library.add(faChevronDown, faArrowAltCircleRight);

export default {
  name: "AboutMe",
  components: {
    "custom-headers": CustomHeaders,
    lottie: Lottie,
    Viewer
  },
  created() {
    //是否顯示more訊息(初始化預設為全部不顯示)
    this.portfolioList.forEach(() => this.isShowMoreDescriptionArr.push(false));
    //監聽window的滾動事件
    window.addEventListener("scroll", this.windowScroll);
  },
  data() {
    return {
      viewerImages: [
        section1LeftSideImg1,
        section1LeftSideImg2,
        section1LeftSideImg3,
        section1RightSideImg1,
        section1RightSideImg2
      ],
      headerTitle: "Portfolio",
      backpageDefaultOptions: { animationData: backArrowJSON.default },
      isShowMoreDescriptionArr: [],
      portfolioList: [
        {
          name: "Reward-System",
          secondaryName: "傭獎系統",
          skills: [
            "Vue3",
            "Element Plus",
            "Pinia",
            "Vitest",
            "Vue Test Utils",
            "SCSS",
            "Axios"
          ],
          skillsFontColor: "#951a1a",
          thumbnailSrc: thumbnailSrc4,
          website: "",
          cardColor: "#951a1a",
          description: {
            article:
              "傭獎系統則是一個從0開始全新的系統，主要讓業務人員能簡單清楚了解複雜的傭金計算、獎酬方式",
            moreContent: {}
          },
          customHtml: `
            <style>
              .file-initroduction {
                display: flex;
                flex-wrap: wrap;
                width: 165px;
                margin-left: auto;
              }
              .file-initroduction > a {
                color:#3ecfdf;
                font-size:1.1rem;
                font-weight:bold;
                display:block;
                margin:5px 0;
                width:100%;
              }
            </style>
            <div class="file-initroduction">
              <a href="https://hackmd.io/@evantsai/rklx7vqd2" target="_blank">- 專案 Readme</a>
              <a href="https://hackmd.io/@evantsai/r1Mq4gxtn" target="_blank">- 共用元件使用說明</a>
            </div>
          `
        },
        {
          name: "Litloyal",
          secondaryName: "會員忠誠系統",
          skills: ["React", "Bootstrap", "Jest", "Styled Component", "Axios"],
          skillsFontColor: "#5a5fa5",
          thumbnailSrc: thumbnailSrc3,
          website: "https://litloyal.com/",
          cardColor: "#5a5fa5",
          description: {
            article:
              "提供商品、點數活動的消費贈點、點數兌換等功能，並且蒐集消費者的消費習慣，做數據的統計，進而可對此數據做一系列的行銷計畫，來創造高忠誠的會員經濟。",
            moreContent: {
              leftSide: [
                {
                  imgSrc: section3LeftSideImg1
                },
                {
                  imgSrc: section3LeftSideImg2
                },
                {
                  imgSrc: section3LeftSideImg3
                }
              ],
              rightSide: [
                {
                  imgSrc: section3RightSideImg1
                },
                {
                  imgSrc: section3RightSideImg2
                }
              ]
            }
          }
        },
        {
          name: "NMS",
          secondaryName: "網路管理系統",
          skills: ["React", "Semantic", "SCSS", "Webpack", "Apexcharts.js"],
          skillsFontColor: "#3ecfdf",
          thumbnailSrc: thumbnailSrc1,
          website: "https://nmsproject.neocities.org/",
          cardColor: "#3ecfdf",
          description: {
            article:
              "用於工業網路通訊的應用，各種終端設備、儀器會藉由switch轉換器的連接，不斷地拓展出去，而NMS網路管理系統，即是透過web介面來遠端蒐集各個switch的信息，進而達成偵測、控制終端設備的能力。",
            moreContent: {
              leftSide: [
                {
                  imgSrc: section1LeftSideImg1
                },
                {
                  imgSrc: section1LeftSideImg2
                },
                {
                  imgSrc: section1LeftSideImg3
                }
              ],
              rightSide: [
                {
                  imgSrc: section1RightSideImg1
                },
                {
                  imgSrc: section1RightSideImg2
                }
              ]
            }
          }
        },
        {
          name: "WM-SYSTEM",
          secondaryName: "物料管理系統",
          skills: ["JQuery", "Bootstrap", "Mustache.js", "Chart.js"],
          skillsFontColor: "#3eabdf",
          thumbnailSrc: thumbnailSrc2,
          website: "https://ignatius.com.tw/wm-system/",
          cardColor: "#3eabdf",
          description: {
            article:
              "用於物料的管理紀錄，可藉由此系統，進行線上請購請款，並將物料的流通紀錄、安全庫存量、有效期限等等，進行全方面的管理。",
            moreContent: {
              leftSide: [
                {
                  imgSrc: section2LeftSideImg1
                },
                {
                  imgSrc: section2LeftSideImg2
                },
                {
                  imgSrc: section2LeftSideImg3
                }
              ],
              rightSide: [
                {
                  imgSrc: section2RightSideImg1
                },
                {
                  imgSrc: section2RightSideImg2
                }
              ]
            }
          }
        }
      ],
      scrollTopDefaultOptions: { animationData: scrollTopJSON.default },
      isShowScrollTopElement: false
    };
  },
  methods: {
    backpageHandleAnimation(anim) {
      this.backpageAnim = anim;
      this.backpageAnim.stop();
    },
    triggerBackpageAnimate() {
      this.backpageAnim.play();
    },
    offBackpageAnimate() {
      this.backpageAnim.stop();
    },
    backpage() {
      this.$router.push("/");
    },
    toggleMoreDescrption(index) {
      const oldIsShowMoreDescriptionArr = this.isShowMoreDescriptionArr.slice();
      oldIsShowMoreDescriptionArr[index] = !oldIsShowMoreDescriptionArr[index];
      this.isShowMoreDescriptionArr = oldIsShowMoreDescriptionArr;
      if (oldIsShowMoreDescriptionArr[index]) {
        setTimeout(() => {
          this.$refs.viewer[index].$el.scrollIntoView({
            behavior: "smooth"
          });
        }, 100);
      }
    },
    viewerInited(viewer) {
      this.$viewer = viewer;
    },
    windowScroll(e) {
      if (e.currentTarget.scrollY >= 400) {
        this.isShowScrollTopElement = true;
      } else {
        this.isShowScrollTopElement = false;
      }
    },
    scrollToTop() {
      window.scroll({
        top: 0,
        behavior: "smooth"
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../css/variable.scss";
.main-content {
  max-width: none;
  flex-wrap: wrap;
  align-items: flex-start;

  .portfolio-article {
    margin-top: 10vw;

    .portfolio-section {
      justify-content: space-around;

      .card-container {
        background-color: $main-color-light-blue;
        color: $color-fff;
        padding: 20px;
        border-radius: 5px;
        box-shadow: 5px 5px 5px #a2a2a2;
        display: flex;
        align-items: center;
        max-width: 575px;
        margin-right: 3vw;
        position: relative;
        min-height: 285px;

        .card-article {
          .card-article-header {
            h1 {
              color: $color-fff;
              margin-bottom: 0.3rem;
              margin-top: 10px;
            }
            span {
              font-size: var(--spacing-m);
            }
          }
          .card-article-content {
            text-align: center;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            margin-top: 35px;

            li {
              padding: 10px;
              width: calc(50% - 5px);
              border: 1px solid #fff;
              border-radius: 5px;
              background-color: #fff;
              color: #3ecfdf;
              margin: 5px 0;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
        }
        .card-img {
          margin-left: 20px;

          img {
            width: 275px;
            border-radius: 5px;
          }
        }
        .website-arrow-container {
          position: absolute;
          right: 20px;
          bottom: 20px;
          font-size: 1rem;
          display: flex;
          align-items: center;
          opacity: 0.6;
          transition: all 0.5s;
          cursor: pointer;

          &:hover {
            opacity: 1;
          }
          > span {
            margin-right: 10px;
          }
          > svg {
            font-size: 2rem;
          }
        }
      }
      .portfolio-section-description {
        font-family: "Microsoft JhengHei";
        width: 50%;
        padding: 45px 0;

        p {
          font-size: 1.2rem;
          font-weight: bold;
          color: $font-color-gray;
          line-height: 2rem;
        }
        .custom-html-container {
          width: 100%;
        }
        .portfolio-section-description-more {
          font-weight: bold;
          color: $main-color-light-blue;
          margin-left: auto;
          margin-right: 30px;
          cursor: pointer;

          > svg {
            margin-left: 10px;
            transition: all 0.5s;

            &.animate {
              transform: rotate(-180deg);
            }
          }
        }
      }
      .divider-container {
        width: 100%;

        .ant-divider-horizontal {
          min-width: 0;
          width: 100%;
          margin: 32px auto;
        }
      }
      .viewer {
        display: flex;
        width: 100%;
        justify-content: center;
      }
      .portfolio-section-imgs-description {
        max-width: 90%;
        border-radius: 5px;
        transition: all 0.7s;
        justify-content: space-between;

        &.animate {
          background-color: #f8f8f8;
          padding: 5% 7%;
          margin-bottom: 35px;

          .imgs-description-left,
          .imgs-description-right {
            height: auto;

            img {
              transform: scale(1);
              cursor: pointer;
            }
          }
        }
        .imgs-description-left,
        .imgs-description-right {
          height: 0;
          overflow: hidden;

          li {
            &:hover {
              img {
                animation: floatUpDown 1.5s infinite;
              }
            }
          }
        }
        .imgs-description-left {
          li {
            margin: 1.5vw 0 3.5vw;
            img {
              width: 100%;
              max-width: 650px;
            }
          }
        }
        .imgs-description-right {
          li {
            margin: 1.5vw 0 3.5vw;
            img {
              width: 100%;
              max-width: 750px;
            }
          }
        }
      }
    }
  }
}
@keyframes floatUpDown {
  0% {
    transform: translateY(0) scale(0.8);
  }
  50% {
    transform: translateY(-30px) scale(0.8);
  }
  100% {
    transform: translateY(0) scale(0.8);
  }
}
</style>
